export default __webpack_public_path__ + "static/media/WF_DGID_WIP.53d16fa6.mp4";